<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button (click)="onSubmit()" [disabled]="formInvalid" title="Guardar" type="button" class="btn btn-outline-success"><i class="fa fa-save"></i> Guardar</button>
    </form>
</nav>


<app-reasignacionpcf-edit [formGroup]="form"
                          [listHoras]="listHoras"
                          [listPuntoInspeccion]="listPuntoInspeccion"
                          [listUbicacion]="listUbicacion"
                          [listInstalacionAutorizada]="listInstalacionAutorizada"
                          (onChangePuntoInspeccion)="obtenerDatosPorPuntoInspeccion($event)">
</app-reasignacionpcf-edit>





